import { Component, OnInit } from "@angular/core";
import { UserService } from "../app/core/user/user.service";
import { Role } from "@bl-enum/role";
import { AuthenticationService } from "@core/authentication/authentication.service";
import { Logger, CryptoUtils } from "msal";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import {MyMonitoringService} from './logging.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(
    private userService: UserService,
    private authService: AuthenticationService,

    private router: Router,
    private myMonitoringService: MyMonitoringService
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      // @ts-ignore
      this.userService.getUserData().subscribe((res: any) => {
        myMonitoringService.logPageView(event.url, event.urlAfterRedirects, res);
      });

    });
  }

  ngOnInit(): void {
    this.authService.broadcastService.subscribe("msal:loginSuccess", () => {
      const name = this.authService.msalService.getAccount().userName;

      this.checkAutorization(name);
      this.myMonitoringService.appInsights.trackEvent({name: 'login-event'}, {name});
      this.userService.setUserData({
        userName: name,
      });
    });

    this.authService.msalService.handleRedirectCallback(
      (authError, response) => {
        if (authError) {
          console.error("Redirect Error: ", authError.errorMessage);
          return;
        }

        console.log("Redirect Success: ", response);
      }
    );

    this.authService.msalService.setLogger(
      new Logger(
        (logLevel, message, piiEnabled) => {
          console.log("MSAL Logging: ", message);
        },
        {
          correlationId: CryptoUtils.createNewGuid(),
          piiLoggingEnabled: false,
        }
      )
    );
  }

  checkAutorization(name: string) {
    this.userService.getUserAuthorization().subscribe(
      (res) => {
        if (!res) {
          this.authService.logout();
        } else {
          this.checkAdmin(name);
        }
      },
      () => {
        //this.authService.logout();
      }
    );
  }

  checkAdmin(userName: string) {
    this.userService.getUserByMail(userName).subscribe((res) => {
      if (res && res.role === Role.ADMIN) {
        this.userService.setIsAdminUser(true);
      } else {
        this.userService.setIsAdminUser(false);
      }
    });
  }
}
